import type { Styles } from 'src/theme/themes';

export const styles = {
  filterColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: 2,
    width: '100%',
  },
} satisfies Styles;
